<template>
  <div class="setting">
    <h1>{{ $t("systemSettings") }}</h1>
    <div class="userinfo-main">
      <div class="edit-section">
        <!-- <i class="iconfont iconbianji edit" v-if="!isEdit" @click="isEdit = !isEdit"></i>
        <template v-else>
          <i class="el-icon-check f-s-18" style="margin-right: 6px" @click="updateInfo"></i>
          <i class="el-icon-close f-s-18" @click="cancelEdit"></i>
        </template> -->
        <el-button class="blue-btn" style="float: right" @click="saveInfo">{{
          $t("save")
        }}</el-button>
      </div>
      <div class="desc-content" style="width: 1000px">
        <div class="info-item">
          <div class="info-item-label">
            {{ $t("maintenanceCompanyDetails") }}
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("company") }}</div>
            <div class="right">
              <el-input
                :placeholder="$t('pleaseInput')"
                :maxlength="64"
                v-model="systemInfo.maintenanceCompany"
              />
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("telephone") }}</div>
            <div class="right">
              <el-input
                :placeholder="$t('pleaseInput')"
                v-model="systemInfo.maintenanceTelephone"
              />
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("projectName") }}</div>
            <div class="right">
              <el-input
                :placeholder="$t('pleaseInput')"
                :maxlength="64"
                v-model="systemInfo.maintenanceProjectName"
              />
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("personOfContact") }}</div>
            <div class="right">
              <el-input
                :placeholder="$t('pleaseInput')"
                :maxlength="64"
                v-model="systemInfo.maintenancePerson"
              />
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("email") }}</div>
            <div class="right">
              <el-input
                :placeholder="$t('pleaseInput')"
                v-model="systemInfo.maintenanceEmail"
                @change="emailChange"
              />
            </div>
          </div>
        </div>
        <div class="info-item">
          <div class="info-item-label">{{ $t("systemConfiguration") }}</div>
          <div class="info-item-content">
            <div class="left">{{ $t("systemLoopCard") }}</div>
            <div class="right">
              <el-select v-model="systemInfo.loopCardCounts">
                <el-option
                  v-for="item in systemLoopCard"
                  class="capitalize"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("loopsInTheSystem") }}</div>
            <div class="right">
              <el-select v-model="systemInfo.loopCounts">
                <el-option
                  v-for="item in systemLoop"
                  class="capitalize"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("LEDPanels") }}</div>
            <div class="right">
              <el-select v-model="systemInfo.ledCounts">
                <el-option
                  v-for="item in chargerCard"
                  class="capitalize"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("chargerCards") }}</div>
            <div class="right">
              <el-select v-model="systemInfo.chargerCardCounts">
                <el-option
                  v-for="item in chargerCard"
                  class="capitalize"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("systemBoards") }}</div>
            <div class="right">
              <el-select v-model="systemInfo.ioBoardCardCounts">
                <el-option
                  v-for="item in systemBoards"
                  class="capitalize"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">{{ $t("systemNetwork") }}</div>
            <div class="right">
              <el-select v-model="systemInfo.networkCardCounts">
                <el-option
                  v-for="item in systemNetwork"
                  class="capitalize"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">
              {{ $t("twoStagesOAT") }}
              <el-tooltip :content="$t('twoStagesVersionTip')" placement="top">
                <i
                  class="el-icon-warning-outline"
                  style="color: #909399; margin-left: 5px; cursor: pointer;"
                ></i>
              </el-tooltip>
            </div>
            <div class="right">
              <el-input
                :placeholder="$t('pleaseInput')"
                v-model="systemInfo.twoStagesOAT"
                maxlength="3"
                @input="handleTwoStagesOATInput"
              />
            </div>
          </div>
          <div class="info-item-content">
            <div class="left">
              {{ $t("twoStagesIDT") }}
              <el-tooltip :content="$t('twoStagesVersionTip')" placement="top">
                <i
                  class="el-icon-warning-outline"
                  style="color: #909399; margin-left: 5px; cursor: pointer;"
                ></i>
              </el-tooltip>
            </div>
            <div class="right">
              <el-input
                :placeholder="$t('pleaseInput')"
                v-model="systemInfo.twoStagesIDT"
                maxlength="3"
                @input="handleTwoStagesIDTInput"
              />
            </div>
          </div>
        </div>
        <div class="info-item">
          <div class="info-item">
            <div class="info-item-label">{{ $t("loopClass") }}</div>
            <div class="info-item-content">
              <div class="left">{{ $t("loop") }}</div>
              <div class="right">{{ $t("classB") }}</div>
            </div>
            <div v-for="i in loopType" :key="i.key">
              <div class="info-item-content">
                <div class="left">{{ i.key }}</div>
                <div class="right">
                  <el-select v-model="systemInfo[i.type]">
                    <el-option
                      v-for="item in yesOrNo"
                      class="capitalize"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="info-item" style="margin-left: 0;border-bottom: none;">
            <div class="info-item-label">{{ $t("setLanguage") }}</div>
            <div class="info-item-content">
              <el-select
                style="width: 200px"
                v-model="systemInfo.language"
                :placeholder="$t('pleaseChoose')"
              >
                <el-option
                  v-for="item in languageArr"
                  class="capitalize"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="info-item">
          <div class="info-item">
            <div class="info-item-label">{{ $t("setPassword") }}</div>
            <div class="info-item-content">
              <div class="left">{{ $t("operatorPassword") }}</div>
              <div class="right">
                <el-input
                  :placeholder="$t('operatorPassword')"
                  maxlength="3"
                  :class="{ password: !operatorPwdVisible }"
                  v-model="systemInfo.operatorPassword"
                >
                  <i
                    slot="suffix"
                    class="iconfont"
                    @click="operatorPwdVisible = !operatorPwdVisible"
                    :class="operatorPwdVisible ? 'iconchakan' : 'iconbiyan'"
                  >
                  </i>
                </el-input>
              </div>
            </div>
            <div class="info-item-content">
              <div class="left">{{ $t("installerPassword") }}</div>
              <div class="right">
                <!-- <el-input class="password" type="text" maxlength="9" :placeholder="$t('installerPassword')" v-model="systemInfo.installerPassword" /> -->
                <el-input
                  :placeholder="$t('installerPassword')"
                  maxlength="10"
                  :class="{ password: !installerPwdVisible }"
                  v-model="systemInfo.installerPassword"
                >
                  <i
                    slot="suffix"
                    class="iconfont"
                    @click="installerPwdVisible = !installerPwdVisible"
                    :class="installerPwdVisible ? 'iconchakan' : 'iconbiyan'"
                  >
                  </i>
                </el-input>
              </div>
              <!-- <template v-else>{{ systemInfo.phone }}</template> -->
            </div>
          </div>
          <div class="info-item" style="margin-left: 0;">
            <div class="info-item-label">{{ $t("setupPrinter") }}</div>
            <div class="info-item-content">
              <div class="left">{{ $t("power") }}</div>
              <div class="right">
                <el-select v-model="systemInfo.printerPower">
                  <el-option
                    v-for="item in handleGlobalArr(config.powerArr)"
                    class="capitalize"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="info-item-content">
              <div class="left">{{ $t("mode") }}</div>
              <div class="right">
                <el-select v-model="systemInfo.printerMode">
                  <el-option
                    v-for="item in handleGlobalArr(config.printMode)"
                    class="capitalize"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="info-item-content" style="height: 55px">
              <div class="left">{{ $t("eventsPrinted") }}</div>
              <div class="right" style="width: 300px; padding-left: 17px">
                <el-checkbox
                  v-model="checkAll"
                  @change="handleCheckAllChange"
                  >{{
                    handleGlobalArr(config.printOption)[0].name
                  }}</el-checkbox
                >
                <el-checkbox-group
                  v-model="checkedPrintEvent"
                  @change="handleCheckedPrintChange"
                >
                  <template
                    v-for="(item, index) in handleGlobalArr(config.printOption)"
                  >
                    <el-checkbox
                      :style="{ width: index % 2 === 1 ? '120px' : '' }"
                      v-if="item.value > 1"
                      :label="item.value"
                      :key="item.value"
                      >{{ item.name }}</el-checkbox
                    >
                  </template>
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <div style="margin-top: 20px;">
            <!-- <div class="info-item-label">{{ $t('salesChannel') }}</div> -->
            <!-- <div class="info-item-content">
            <div class="left">{{ $t('mark') }}</div>
            <div class="right">
              <el-select v-if="canEdit" style="width: 200px" v-model="systemInfo.salesChannel" :placeholder="$t('pleaseChoose')">
                <el-option
                  v-for="item in markArr"
                  class="capitalize"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
              <template v-else>
                {{ systemInfo.salesChannel }}
              </template>
            </div>
          </div> -->
            <div class="info-item-content">
              <div class="left">{{ $t("user") }}</div>
              <div class="right">
                {{ systemInfo.salesChannelUser }}
              </div>
            </div>
            <div class="info-item-content">
              <div class="left">{{ $t("time") }}</div>
              <div class="right">
                {{ systemInfo.salesChannelTime }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-item" style="width: 800px;border-bottom: none;">
        <div class="info-item-label">{{ $t("notes") }}</div>
        <div class="info-item-content">
          <el-input type="text" v-model="systemInfo.note" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPanelDetail, setSystem } from "../../api/panel";
import config from "../../common/config";
import Cookies from "js-cookie";
import { EventBus } from "../../store/eventBus";

export default {
  name: "systemSetting",
  data() {
    return {
      isEdit: false,
      languageArr: this.handleGlobalArr(config.languageArr),
      markArr: config.markArr,
      config: config,
      systemInfo: {},
      systemInfoCopy: {},
      yesOrNo: [
        {
          name: this.$t("yes"),
          value: 1
        },
        {
          name: this.$t("no"),
          value: 0
        }
      ],
      systemLoop: [
        {
          name: 1,
          value: 1
        },
        {
          name: 2,
          value: 2
        },
        {
          name: 4,
          value: 4
        },
        {
          name: 6,
          value: 6
        },
        {
          name: 8,
          value: 8
        }
      ],
      systemLoopCard: [
        {
          name: 1,
          value: 1
        },
        {
          name: 2,
          value: 2
        },
        {
          name: 3,
          value: 3
        },
        {
          name: 4,
          value: 4
        }
      ],
      chargerCard: [
        {
          name: 0,
          value: 0
        },
        {
          name: 1,
          value: 1
        }
      ],
      systemBoards: [
        {
          name: 0,
          value: 0
        },
        {
          name: 1,
          value: 1
        },
        {
          name: 2,
          value: 2
        },
        {
          name: 3,
          value: 3
        },
        {
          name: 4,
          value: 4
        }
      ],
      systemNetwork: [
        {
          name: 0,
          value: 0
        },
        {
          name: 1,
          value: 1
        }
      ],
      panelId: this.$route.query.panelId,
      projectId: this.$route.query.projectId,
      operatorPwdVisible: false,
      installerPwdVisible: false,
      canEdit: false,
      checkAll: false,
      checkedPrintEvent: [],
      isShow: Cookies.get(config.role) / 1 === 3,
      loopType: [
        {
          key: 1,
          type: "loopAType"
        },
        {
          key: 2,
          type: "loopBType"
        },
        {
          key: 3,
          type: "loopCType"
        },
        {
          key: 4,
          type: "loopDType"
        },
        {
          key: 5,
          type: "loopEType"
        },
        {
          key: 6,
          type: "loopFType"
        },
        {
          key: 7,
          type: "loopGType"
        },
        {
          key: 8,
          type: "loopHType"
        }
      ]
    };
  },
  mounted() {
    this.getPanelDetail();
    this.canEdit = +Cookies.get(config.role) === 3;
    EventBus.$on("checkSave", cb => {
      const data = this.handleData();
      if (data.length > 0) {
        this.checkCommit();
      } else {
        cb();
      }
    });
  },
  methods: {
    getPanelDetail() {
      getPanelDetail({
        panelId: this.panelId,
        projectId: this.projectId
      }).then(res => {
        this.systemInfo = res.data;
        this.systemInfoCopy = JSON.parse(JSON.stringify(res.data));
        const arr = this.toBinary(this.systemInfo.printerEvent);
        const checkArr = [];
        // 全选
        if (arr[0] === "1" || this.systemInfo.printerEvent >= 30) {
          this.checkAll = true;
          this.checkedPrintEvent = [2, 3, 4, 5];
        } else {
          this.checkAll = false;
          arr.slice(1).map((n, i) => {
            if (n === "1") {
              checkArr.push(i + 2);
            }
          });
          this.checkedPrintEvent = checkArr;
        }
      });
    },
    updateInfo() {},
    cancelEdit() {
      this.isEdit = !this.isEdit;
    },
    saveInfo(e = null, done) {
      // 2020-7-31 修改邮箱不验证
      // if (this.systemInfo.maintenanceEmail && !config.checkEmail(this.systemInfo.maintenanceEmail)) {
      //   this.$message.error(this.$t('emailError'))
      //   return
      // }
      const operatorPassword = this.systemInfo.operatorPassword;
      if (operatorPassword) {
        if (
          isNaN(operatorPassword) ||
          operatorPassword.length !== 3 ||
          operatorPassword % 1 !== 0
        ) {
          this.$message.error(this.$t("operatorPasswordCheck"));
          return;
        }
      }
      const installerPassword = this.systemInfo.installerPassword;
      if (installerPassword) {
        if (
          isNaN(installerPassword) ||
          installerPassword.length !== 10 ||
          operatorPassword % 1 !== 0
        ) {
          this.$message.error(this.$t("installerPasswordCheck"));
          return;
        }
      }
      const params = {
        id: this.systemInfo.id,
        maintenanceCompany: this.systemInfo.maintenanceCompany,
        maintenanceProjectName: this.systemInfo.maintenanceProjectName,
        maintenanceTelephone: this.systemInfo.maintenanceTelephone,
        maintenanceProjectName: this.systemInfo.maintenanceProjectName,
        maintenancePerson: this.systemInfo.maintenancePerson,
        maintenanceEmail: this.systemInfo.maintenanceEmail,
        loopAType: this.systemInfo.loopAType,
        loopBType: this.systemInfo.loopBType,
        loopCType: this.systemInfo.loopCType,
        loopDType: this.systemInfo.loopDType,
        loopEType: this.systemInfo.loopEType,
        loopFType: this.systemInfo.loopFType,
        loopGType: this.systemInfo.loopGType,
        loopHType: this.systemInfo.loopHType,
        printerPower: this.systemInfo.printerPower,
        printerMode: this.systemInfo.printerMode,
        // printerEvent: this.systemInfo.printerEvent,
        language: this.systemInfo.language,
        operatorPassword: this.systemInfo.operatorPassword || "",
        installerPassword: this.systemInfo.installerPassword || "",
        loopCardCounts: this.systemInfo.loopCardCounts,
        loopCounts: this.systemInfo.loopCounts,
        ledCounts: this.systemInfo.ledCounts,
        chargerCardCounts: this.systemInfo.chargerCardCounts,
        ioBoardCardCounts: this.systemInfo.ioBoardCardCounts,
        networkCardCounts: this.systemInfo.networkCardCounts,
        note: this.systemInfo.note,
        twoStagesOAT: this.systemInfo.twoStagesOAT,
        twoStagesIDT: this.systemInfo.twoStagesIDT
      };
      params.printerEvent = this.checkAll
        ? 31
        : this.toDecimal(this.checkedPrintEvent);
      if (this.canEdit && this.systemInfo.salesChannel) {
        params.salesChannel = this.systemInfo.salesChannel;
      }
      setSystem(params).then(res => {
        this.$message.success(this.$t("saveSuccess"));
        this.getPanelDetail();
        if (done) {
          done();
        }
      });
    },
    emailChange(val) {
      // if (!config.checkEmail(val)) {
      //   this.$message.error(this.$t('emailError'))
      // }
    },
    handleTwoStagesOATInput(val) {
      this.systemInfo.twoStagesOAT = val.replace(/[^0-9]/g, "");
    },
    handleTwoStagesIDTInput(val) {
      this.systemInfo.twoStagesIDT = val.replace(/[^0-9]/g, "");
    },
    handleCheckAllChange(val) {
      this.checkedPrintEvent = val ? [2, 3, 4, 5] : [];
    },
    handleCheckedPrintChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.config.printOption.length - 1;
    },
    // 回显事件
    toBinary(num) {
      if (isNaN(num)) {
        return [];
      } else {
        return num
          .toString(2)
          .split("")
          .reverse();
      }
    },
    // 二进制转为十进制
    toDecimal(arr) {
      // 全选
      let num = 0;
      arr.map(n => {
        num += 1 * 2 ** (n - 1);
      });
      return num;
    },
    handleData() {
      const data = [];
      const keys = [
        "maintenanceCompany",
        "maintenanceProjectName",
        "maintenanceTelephone",
        "maintenanceProjectName",
        "maintenancePerson",
        "maintenanceEmail",
        "loopAType",
        "loopBType",
        "loopCType",
        "loopDType",
        "loopEType",
        "loopFType",
        "loopGType",
        "loopHType",
        "printerPower",
        "printerMode",
        "language",
        "operatorPassword",
        "installerPassword",
        "loopCardCounts",
        "loopCounts",
        "ledCounts",
        "chargerCardCounts",
        "ioBoardCardCounts",
        "networkCardCounts",
        "note",
        "salesChannel",
        "twoStagesOAT",
        "twoStagesIDT"
      ];
      for (let i = 0, len = keys.length; i < len; i++) {
        const oldValue =
          this.systemInfoCopy[keys[i]] !== 0
            ? this.systemInfoCopy[keys[i]] || ""
            : 0;
        const newValue =
          this.systemInfo[keys[i]] !== 0 ? this.systemInfo[keys[i]] || "" : 0;
        if (newValue != oldValue) {
          data.push(keys[i]);
          break;
        }
      }
      const printerEvent = this.checkAll
        ? 31
        : this.toDecimal(this.checkedPrintEvent);
      if (printerEvent != this.systemInfoCopy["printerEvent"]) {
        // 后端创建项目该值默认为1，是全选(31也是)
        // 这里只排除默认为1时的不相等(1 !== 31)
        if (
          this.systemInfo["printerEvent"] === 31 &&
          this.systemInfoCopy["printerEvent"] === 1
        ) {
          data.push("printerEvent");
        }
      }
      console.log(data);
      return data;
    },
    checkCommit() {
      this.$msgbox({
        title: this.$t("prompt"),
        message: this.$t("unsavedRemind"),
        showClose: false,
        closeOnClickModal: false,
        showCancelButton: true,
        confirmButtonText: this.$t("sure"),
        cancelButtonText: this.$t("cancel"),
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            this.saveInfo(null, done);
          } else {
            // this.systemInfo = JSON.parse(JSON.stringify(this.systemInfoCopy))
            // const arr = this.toBinary(this.systemInfo.printerEvent)
            // const checkArr = []
            // // 全选
            // if (arr[0] === '1' || this.systemInfo.printerEvent >= 30) {
            //   this.checkAll = true
            //   this.checkedPrintEvent = [2, 3, 4, 5]
            // } else {
            //   this.checkAll = false
            //   arr.slice(1).map((n, i) => {
            //     if (n === '1') {
            //       checkArr.push(i + 2)
            //     }
            //   })
            //   this.checkedPrintEvent = checkArr
            // }
            done();
          }
        }
      }).then(action => {});
    }
  },
  beforeRouteLeave(to, from, next) {
    // 在token失效时,会跳转到/，此时不必拦截
    if (to.path !== "/") {
      const data = this.handleData();
      if (data.length > 0) {
        next(false);
        this.checkCommit();
      } else {
        next();
      }
    } else {
      next();
    }
  },
  beforeDestroy() {
    EventBus.$off("checkSave");
  }
};
</script>
<style lang="less" scoped>
.userinfo-main {
  .info-item {
    margin-top: 10px;
    min-height: 54px;
    padding: 10px 0;
    border-bottom: 1px solid #ccdeee;
    display: inline-block;
    vertical-align: top;
    // width: calc(50% - 50px);
    width: 450px;
    // border: 1px solid red;
    &:nth-child(odd) {
      margin-right: 50px;
    }
    &:nth-child(even) {
      margin-left: 50px;
    }
    .info-item-label {
      font-size: 16px;
      color: #333;
    }
    .info-item-content {
      margin-top: 20px;
      height: 22px;
      display: flex;
      // justify-content: space-between;
      .left {
        width: 45%;
      }
      .right {
        width: 50%;
        i {
          line-height: 32px;
          .f-s-12();
          position: absolute;
          right: 0;
          z-index: 1111;
          cursor: pointer;
        }
        .iconbiyan {
          .f-s-18();
          position: relative;
          top: -1px;
          left: -1px;
        }
      }
    }
  }
  .user-title {
    font-size: 16px;
    margin: 20px 0 10px;
  }
  // .edit-section {
  // text-align: right;
  //   height: 20px;
  //   overflow: hidden;
  //   i {
  //     cursor: pointer;
  //   }
  // }
}
h1 {
  font-size: 24px;
  font-weight: 400;
}
// @font-face {
//   font-family: passwordFont;
//   src: url(../../assets/font/password.ttf);
//   font-weight: normal;
// }
</style>

<style lang="less">
.setting {
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #83909b;
    border-color: #83909b;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #83909b;
  }
  .el-checkbox__inner {
    background-color: transparent;
  }
}
</style>
